import { render, staticRenderFns } from "./t-empty-wrapper.vue?vue&type=template&id=229766f2&scoped=true&lang=pug"
import script from "./t-empty-wrapper.vue?vue&type=script&lang=js"
export * from "./t-empty-wrapper.vue?vue&type=script&lang=js"
import style0 from "./t-empty-wrapper.vue?vue&type=style&index=0&id=229766f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229766f2",
  null
  
)

export default component.exports